import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-container content0 px-3 py-2" }
const _hoisted_2 = { class: "fixed-header px-3" }
const _hoisted_3 = { class: "card card0" }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = { class: "scrollable-content" }
const _hoisted_6 = {
  class: "d-block main-block pt-2 text-start ps-3 pb-3",
  style: {"font-weight":"400","font-size":"14pt"}
}
const _hoisted_7 = {
  class: "d-block",
  style: {"font-weight":"500","font-size":"20pt","line-height":"1"}
}
const _hoisted_8 = { class: "main-block pt-2" }
const _hoisted_9 = { class: "d-flex row ps-2" }
const _hoisted_10 = { class: "d-flex col-12" }
const _hoisted_11 = { class: "d-flex col-6 p-0 m-0 cdiv" }
const _hoisted_12 = { class: "me-1 w-100 text-start" }
const _hoisted_13 = { class: "d-flex col-6 p-0 m-0 cdiv" }
const _hoisted_14 = { class: "ms-1 me-2 w-100 text-start" }
const _hoisted_15 = { class: "main-block pt-0" }
const _hoisted_16 = { class: "d-flex row ps-2" }
const _hoisted_17 = { class: "d-flex col-12" }
const _hoisted_18 = { class: "d-flex col-6 p-0 m-0 cdiv" }
const _hoisted_19 = { class: "cblock me-1 w-100 text-start" }
const _hoisted_20 = { class: "cblock2 ms-1 me-2 w-100 text-start" }
const _hoisted_21 = { class: "recommendations px-2" }
const _hoisted_22 = { class: "recommendations__container" }
const _hoisted_23 = { class: "recommendations__scroll" }
const _hoisted_24 = { class: "article-card__header" }
const _hoisted_25 = { class: "article-card__title" }
const _hoisted_26 = { class: "article-card__time" }
const _hoisted_27 = { class: "article-card__preview" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_OverlayBadge = _resolveComponent("OverlayBadge")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_RiskWidget = _resolveComponent("RiskWidget")!
  const _component_LipProfileWidget = _resolveComponent("LipProfileWidget")!
  const _component_VesDynWidget = _resolveComponent("VesDynWidget")!
  const _component_DocBookWidget = _resolveComponent("DocBookWidget")!
  const _component_LipProfilePage = _resolveComponent("LipProfilePage")!
  const _component_Drawer = _resolveComponent("Drawer")!
  const _component_RiskProfilePage = _resolveComponent("RiskProfilePage")!
  const _component_WeightBlock = _resolveComponent("WeightBlock")!
  const _component_ProfilePage = _resolveComponent("ProfilePage")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Toolbar, { class: "card0" }, {
            start: _withCtx(() => [
              _createElementVNode("div", {
                class: "flex items-center gap-2 header-profile",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visibleProfile = true))
              }, [
                _createVNode(_component_Avatar, {
                  image: "https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png",
                  shape: "square",
                  size: "large",
                  class: "testcss"
                }),
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "inline-flex flex-col items-start" }, [
                  _createElementVNode("span", { class: "font-bold" })
                ], -1))
              ])
            ]),
            center: _withCtx(() => _cache[10] || (_cache[10] = [])),
            end: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_OverlayBadge, {
                  value: "3",
                  size: "small"
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createElementVNode("i", {
                      class: "pi pi-bell",
                      style: {"font-size":"1.5rem","color":"gray"}
                    }, null, -1)
                  ])),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[12] || (_cache[12] = _createTextVNode(" Добро пожаловать, ")),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.profile.first_name), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_RiskWidget, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visibleRisk = true))
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_LipProfileWidget, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = true))
                    })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_VesDynWidget, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.visibleBottom = true))
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: "d-flex col-6 p-0 m-0 cdiv",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.navigateToDoctors && _ctx.navigateToDoctors(...args)))
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_DocBookWidget)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "recommendations__title ps-2 pt-4 text-start" }, " Мои рекомендации ", -1)),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "article-card text-start"
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("h3", _hoisted_25, _toDisplayString(article.title), 1),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(article.time), 1)
                  ]),
                  _createElementVNode("p", _hoisted_27, _toDisplayString(article.preview), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("footer", null, null, -1)),
        _createVNode(_component_Drawer, {
          visible: _ctx.visible,
          "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
          header: "Липидный профиль",
          position: "bottom",
          class: "drawer-fullscreen"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LipProfilePage)
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_Drawer, {
          visible: _ctx.visibleRisk,
          "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visibleRisk) = $event)),
          header: "Персональный риск",
          position: "bottom",
          class: "drawer-fullscreen"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RiskProfilePage)
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_Drawer, {
          visible: _ctx.visibleBottom,
          "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visibleBottom) = $event)),
          header: "Масса тела",
          position: "bottom",
          class: "drawer-fullscreen"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_WeightBlock)
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_Drawer, {
          visible: _ctx.visibleProfile,
          "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.visibleProfile) = $event)),
          header: "Профиль",
          position: "top",
          class: "drawer-fullscreen"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ProfilePage)
          ]),
          _: 1
        }, 8, ["visible"])
      ])
    ])
  ]))
}